"use client";

import { useEffect } from "react";
import Script from "next/script";

export default function PaymentClosePage() {
  useEffect(() => {
    // INIStdPay_close.js 로드 실패 시 fallback
    const timer = setTimeout(() => {
      window.close();
    }, 3000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-sm text-muted-foreground">결제 창을 닫는 중...</p>
      <Script
        src="https://stdpay.inicis.com/stdjs/INIStdPay_close.js"
        strategy="afterInteractive"
      />
    </div>
  );
}
